import { composeWithDevTools } from '@redux-devtools/extension';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import userReducer from '../reducers/userReducer';
import configReducer from '../reducers/configReducer';
import resourceReducer from '../reducers/resourceReducer';
import logisticsResourceReducer from '../reducers/logisticsResourceReducer';
import loadingReducer from '../reducers/loadingReducer';
import lineInventoryReducer from '../reducers/lineInventoryReducer';
import mdrReducer from '../reducers/mdrReducer';
import speechRecognitionReducer from '../reducers/speechRecognitionReducer';
import pickingReducer from '../reducers/pickingReducer';
import loweringReducer from '../reducers/loweringReducer';
import pabReplanningReducer from '../reducers/pabReplanningReducer';
import conversationReducer from '../reducers/conversationReducer';
import signalRMiddleware from '../middleware/signalRMiddleware';
import inventoryReducer from '../reducers/inventoryReducer';
import locationReducer from '../reducers/locationReducer';
import plantReducer from '../reducers/plantReducer';
import areaReducer from '../reducers/areaReducer';
import unitReducer from '../reducers/unitReducer';
import justificationReducer from '../reducers/justificationReducer';
import messageReducer from '../reducers/messageReducer';
import volumeReducer from '../reducers/volumeReducer';
import linePickingReducer from '../reducers/linePickingReducer';
import usersElogReducer from '../reducers/usersElogReducer';
import deliveryReducer from '../reducers/deliveryReducer';
import monitorReducer from '../reducers/monitorReducer';
import orderGroupReducer from '../reducers/orderGroupReducer';
import physicalConfirmationReducer from '../reducers/physicalConfirmationReducer';
import packListReducer from '../reducers/packListReducer';
import logReducer from '../reducers/logReducer';
import movementTypeReducer from '../reducers/movementTypeReducer';
import truckKanbanReducer from '../reducers/truckKanbanReducer';
import stockReducer from '../reducers/stockReducer';
import loweringDeliveryReducer from '../reducers/loweringDeliveryReducer';
import loadUnloadReducer from '../reducers/loadUnloadReducer';
import supplierReducer from '../reducers/supplierReducer';
import containerReducer from '../reducers/containerReducer';
import issuerReducer from '../reducers/issuerReducer';

export const getStore = () => {
    const reducers = combineReducers({
        userReducer,
        resourceReducer,
        configReducer,
        logisticsResourceReducer,
        loadingReducer,
        lineInventoryReducer,
        mdrReducer,
        speechRecognitionReducer,
        pickingReducer,
        conversationReducer,
        inventoryReducer,
        locationReducer,
        plantReducer,
        areaReducer,
        unitReducer,
        justificationReducer,
        messageReducer,
        volumeReducer,
        linePickingReducer,
        usersElogReducer,
        deliveryReducer,
        monitorReducer,
        orderGroupReducer,
        physicalConfirmationReducer,
        packListReducer,
        logReducer,
        movementTypeReducer,
        truckKanbanReducer,
        stockReducer,
        loweringReducer,
        loweringDeliveryReducer,
        pabReplanningReducer,
        loadUnloadReducer,
        supplierReducer,
        containerReducer,
        issuerReducer
    });
    const store = createStore(reducers, composeWithDevTools(applyMiddleware(thunk, signalRMiddleware)));
    return store;
}